<template>
    <div class="chart-font">
        <div class="row">
            <div class="col title text-muted">{{ title }}</div>
            <div class="col-md-auto"><a href="/reports/files/837">More...</a></div>
        </div>
        <div v-if="files.length" class="table-responsive">
            <table class="table table-sm">
                <thead>
                    <th>Filename</th>
                    <th>Upload Type</th>                    
                    <th v-if="showClient">Client</th>
                    <th>Uploaded By</th>                
                    <th>Uploaded At</th>
                    <th></th>
                </thead>
                <tbody>
                    <tr v-for="file in files" :key="'edi-file-upload-' + file.id">
                        <td class="d-inline-block text-truncate" style="max-width: 350px;">
                            <i :class="getIconClass(file.status.id)" :title="file.status.name"></i>
                            <a :href="'/files/837/' + file.id" class="px-1" :title="file.filename">{{ file.filename }}</a></td>
                        <td>{{ file.upload_type }}</td>
                        <td v-if="showClient" class="d-inline-block text-truncate" style="max-width: 100px" :title="file.client_name">{{ file.client_name }}</td>
                        <td>{{ file.uploaded_by }}</td>                      
                        <td class="text-nowrap">{{ file.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                        <td><a :href="'/files/837/download/' + file.id" title="Download File"><i class="fas fa-lg fa-file-download"></i></a></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="border-top">
            <h5 class="text-muted text-center mt-2">No uploaded 837 files.</h5>
        </div> 
    </div>  
</template>

<script>
import { ProcessingStatus } from '../../constants.js';

export default {
    props: {
        title: String,
        href: String
    },
    data() {
        return {
            files: [],
            loading: false,

            ProcessingStatus: ProcessingStatus
        }
    },
    computed: {
        showClient: function () {
            return this.files && [...new Set(this.files.map(file => file.client_name))].length > 1;
        }
    },
    methods: {
        refresh: function () {

            this.loading = true;
            axios.get(this.href)
                .then((response) => {
                    this.files = response.data.files;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },
        getIconClass: function (id) {
            let retval = 'fas fa-lg ';
            switch(id)
            {
                case ProcessingStatus.Processing:
                    retval += 'fa-spinner text-muted';
                    break;
                case ProcessingStatus.Failed:
                    retval += 'fa-exclamation-circle text-danger';
                    break;
                case ProcessingStatus.Succeeded:
                    retval += 'fa-check-circle text-success';
                    break;
                case ProcessingStatus.Duplicate:
                case ProcessingStatus.Partial:
                    retval += 'fa-exclamation-triangle text-warning';
                    break;
                default:
                    break;
            }
            return retval;
        }        
    },
    created() {
        this.refresh();
    }
}
</script>

<style scoped>
    .chart-font {
        font-size: 12px;
        font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
        font-style: normal;
        font-weight: bold;
        color: #666;
    }
</style>